module.exports = __webpack_public_path__ + "static/media/backstep_icon.ac6a2f4f.svg";